import { gql } from '@apollo/client'

const DISHES_USED_METADATA_COUNTS_QUERY = gql`
  query dishesUsedMetadataCountsQuery($filters: DishFiltersInput!) {
    dishesUsedMetadataCounts(filters: $filters) {
      dishType {
        id
        count
      }
      courseType {
        id
        count
      }
    }
  }
`

export default DISHES_USED_METADATA_COUNTS_QUERY
